import classNames from 'classnames';
import { FormikErrorMessage } from 'components/FormikErrorMessage/FormikErrorMessage';
import { FormikNumberField } from 'components/FormikNumberField/FormikNumberField';
import { useLocale } from 'containers/App/LocaleContext';
import type { FormikProps } from 'formik';
import type { FC } from 'react';
import type { FormSettingsValues } from './GraphProtocolsSettings';

interface Props {
  formik: FormikProps<FormSettingsValues>;
  name: keyof FormSettingsValues;
  thickness: 'thin' | 'medium' | 'thick';
}

export const LineThicknessField: FC<Props> = (props) => {
  const msg = useLocale();

  return (
    <div className='flex h-10 flex-row items-center'>
      <span
        className={classNames(
          'graph-layout-settings-protocol-options__thickness',
          `graph-layout-settings-protocol-options__thickness-${props.thickness}`,
        )}
        style={{
          borderBottomColor: props.formik.values.color,
          borderBottomStyle: props.formik.values.pattern,
        }}
      />
      <span className='ipf-form-label mb-0 shrink-0 whitespace-nowrap pl-5 pr-2.5'>
        {
          msg.canvasGraph.graphSidePanel.layoutSettings.protocolSettingsWindow
            .form.upTo
        }
      </span>
      <FormikNumberField
        className='ipf-input w-lgu-24'
        formik={props.formik}
        min={1}
        name={props.name}
      />
      <span className='ipf-form-label mb-0 shrink-0 whitespace-nowrap px-2.5'>
        {
          msg.canvasGraph.graphSidePanel.layoutSettings.protocolSettingsWindow
            .form.edges
        }
      </span>
      <FormikErrorMessage
        formik={props.formik}
        name={props.name}
        icon='fa-exclamation-circle'
        className='graph-layout-settings-error-message leading-lgu-6 ml-lgu-12'
      />
    </div>
  );
};
